import React from 'react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { ILocation } from 'src/types/Location';

export interface CreateReportFormFields {
  reportName: string;
  startDate: Date | null;
  endDate: Date | null;
  locations: ILocation[];
  employeeEmail: string;
}

interface CreateReportFormProviderProps {
  children: React.ReactNode;
}

export const CreateReportFormProvider: React.FC<CreateReportFormProviderProps> =
  ({ children }) => {
    const methods = useForm<CreateReportFormFields>({
      mode: 'onChange',
      defaultValues: {
        reportName: '',
        startDate: null,
        endDate: null,
        locations: [],
        employeeEmail: '',
      },
    });

    return <FormProvider {...methods}>{children}</FormProvider>;
  };
